'use client';

import type { LanguageCategory } from '@/types/custom';
import { twMerge } from 'tailwind-merge';

type FlagStyle = 'text-iso' | 'text-full' | 'flag';

interface FlagProps {
    language: LanguageCategory | undefined;
    className?: string;
    style?: FlagStyle;
}

export default function Flag({ language, className, style = 'text-iso' }: FlagProps) {
    // Function to determine the background color class based on the country code
    const getBackgroundColorClass = (code: string) => {
        switch (code) {
            case 'ENG':
                return 'bg-haug-coral-100';
            case 'NLD':
                return 'bg-haug-blue-100';
            default:
                return 'bg-haug-lila-100';
        }
    };

    const backgroundColorClass = getBackgroundColorClass(language?.languageCode || '');

    // Tooltip text based on country code
    const tooltipText = `${language?.languageName}`;

    if (style === 'text-full') {
        return (
            <div
                className={twMerge(
                    'px-1 py-0.5 text-white uppercase',
                    backgroundColorClass,
                    className
                )}
                title={tooltipText}
            >
                {language?.languageName}
            </div>
        );
    }

    return (
        <div
            className={twMerge('px-1 py-0.5 text-white uppercase', backgroundColorClass, className)}
            title={tooltipText}
        >
            {language?.languageCode}
        </div>
    );
}
